import { Search } from "/app/src/components/generic/components/search";

/**
 * Filters component to render search filters.
 *
 * @param {Object} props - The properties object.
 * @param {Function} props.setSearchString - A function to set the search string.
 */
export default function Filters({
  setSearchString,
}: {
  setSearchString: (searchString: string) => void;
}) {
  return (
    <div className="integrationListFilters">
      <Search setSearchString={setSearchString} />
    </div>
  );
}
